import React, {useState} from 'react';
import {Col, Row, DatePicker, Checkbox} from 'antd';
import InputField from '../../../../input-field';
import DividerBlock from "../../../../divider-block";
import SelectField from "../../../../select-field";
import i18n from "../../../../../i18n";

export default function MainDataFields({ stepFields, setFields, getFieldErrors, orgFormId, edit = false }) {
    const [notRegisteredATI, setNotRegisteredATI] = useState(false);

	let dividerStyle = {
    margin: "15px 0px 45px 0px",
    display: "block",
    clear: "both",
    width: "100%",
    minWidth: "100%",
    height: "1px",
  };
    const firstToUpper = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1);
    };

    return (
      <>
        <Row gutter={[16, 24]}>
          <Col lg={8} md={8} sm={24} xs={24}>
            <InputField
              name="name"
              title={i18n.t('modals.modalCreateNewLegalEntity.fields.name.title')}
              label={i18n.t('modals.modalCreateNewLegalEntity.fields.name.title')}
              required={true}
              value={stepFields.name}
              setValue={(value) => {
                setFields({ ...stepFields, name: value });
              }}
              getFieldErrors={getFieldErrors}
            />
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <InputField
              name="legalNumber"
              title={i18n.t('modals.modalCreateNewLegalEntity.fields.legalNumberBel.title')}
              label={i18n.t('modals.modalCreateNewLegalEntity.fields.legalNumberBel.label')}
              required={true}
              value={stepFields.legalNumber}
              setValue={(value) => {
                setFields({ ...stepFields, legalNumber: value });
              }}
              getFieldErrors={getFieldErrors}
            />
          </Col>
        </Row>

        <span className="divider-label">{i18n.t('modals.modalCreateNewLegalEntity.divider.contacts2')}</span>
        <DividerBlock style={dividerStyle} />

        <Row gutter={[16, 24]}>
          <Col lg={8} md={8} sm={24} xs={24}>
            <InputField
              name="firstName"
              title={i18n.t('modals.modalCreateNewLegalEntity.fields.firstName.title')}
              label={i18n.t('modals.modalCreateNewLegalEntity.fields.firstName.title')}
              required={true}
              value={stepFields.firstName}
              setValue={(value) => {
                setFields({ ...stepFields, firstName: firstToUpper(value) });
              }}
              getFieldErrors={getFieldErrors}
            />
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <InputField
              name="secondName"
              title={i18n.t('modals.modalCreateNewLegalEntity.fields.secondName.title')}
              label={i18n.t('modals.modalCreateNewLegalEntity.fields.secondName.title')}
              required={true}
              value={stepFields.secondName}
              setValue={(value) => {
                setFields({ ...stepFields, secondName: firstToUpper(value) });
              }}
              getFieldErrors={getFieldErrors}
            />
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <InputField
              name="patronymic"
              title={i18n.t('modals.modalCreateNewLegalEntity.fields.patronymic.title')}
              label={i18n.t('modals.modalCreateNewLegalEntity.fields.patronymic.title')}
              required={true}
              value={stepFields.patronymic}
              setValue={(value) => {
                setFields({ ...stepFields, patronymic: firstToUpper(value) });
              }}
              getFieldErrors={getFieldErrors}
            />
          </Col>
        </Row>
        <Row gutter={[16, 24]}>
          {orgFormId !== 16 ? (
            <>
              <Col lg={8} md={8} sm={24} xs={24}>
                <InputField
                  name="position"
                  label={i18n.t('modals.modalCreateNewLegalEntity.fields.position.title')}
                  value={stepFields.position}
                  setValue={(value) =>
                    setFields({ ...stepFields, position: firstToUpper(value) })
                  }
                  getFieldErrors={getFieldErrors}
                />
              </Col>
              <Col lg={8} md={8} sm={24} xs={24}>
                <SelectField
                  title={i18n.t('modals.modalCreateNewLegalEntity.fields.legalReason.title')}
                  name="legalReason"
                  selectedValue={stepFields.legalReason}
                  values={stepFields.legalReasonsList}
                  onChange={(value) => {
                    setFields({
                      ...stepFields,
                      legalReason: value,
                    });
                  }}
                  getErrors={getFieldErrors}
                  placeholder={i18n.t('modals.modalCreateNewLegalEntity.fields.legalReason.placeholder')}
                  notFoundText={null}
                  showArrow={true}
                  style={{ width: "100%" }}
                />
              </Col>
            </>
          ) : (
            <>
              <Col lg={8} md={8} sm={24} xs={24}>
                <InputField
                  name="legalReason"
                  isDisabled={true}
                  label={i18n.t('modals.modalCreateNewLegalEntity.fields.legalReason.title')}
                  value={i18n.t('modals.modalCreateNewLegalEntity.fields.legalReason.value')}
                  setValue={(value) =>
                    setFields({ ...stepFields, legalReason: value })
                  }
                  getFieldErrors={getFieldErrors}
                />
              </Col>
            </>
          )}
        </Row>

        <span className="divider-label">{i18n.t('modals.modalCreateNewLegalEntity.divider.bank2')}</span>
        <DividerBlock style={dividerStyle} />

        <Row gutter={[16, 24]}>
          <Col lg={8} md={8} sm={24} xs={24}>
            <InputField
              name="bankName"
              title={i18n.t('modals.modalCreateNewLegalEntity.fields.bankName.title')}
              label={i18n.t('modals.modalCreateNewLegalEntity.fields.bankName.title')}
              required={true}
              value={stepFields.bankName}
              setValue={(value) => {
                setFields({ ...stepFields, bankName: value });
              }}
              getFieldErrors={getFieldErrors}
            />
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <InputField
              name="accountNumber"
              title={i18n.t('modals.modalCreateNewLegalEntity.fields.accountNumber.title')}
              label={i18n.t('modals.modalCreateNewLegalEntity.fields.accountNumber.title')}
              required={true}
              value={stepFields.accountNumber}
              setValue={(value) => {
                setFields({ ...stepFields, accountNumber: value });
              }}
              getFieldErrors={getFieldErrors}
            />
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <InputField
              name="bankUnp"
              label={i18n.t('modals.modalCreateNewLegalEntity.fields.bankUnp.title')}
              title={i18n.t('modals.modalCreateNewLegalEntity.fields.bankUnp.title')}
              required={true}
              value={stepFields.bankUnp}
              setValue={(value) => {
                setFields({ ...stepFields, bankUnp: value });
              }}
              getFieldErrors={getFieldErrors}
            />
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <InputField
              name="bic"
              label={i18n.t('modals.modalCreateNewLegalEntity.fields.bic.title')}
              title={i18n.t('modals.modalCreateNewLegalEntity.fields.bic.title')}
              required={true}
              value={stepFields.bic}
              setValue={(value) => {
                setFields({ ...stepFields, bic: value });
              }}
              getFieldErrors={getFieldErrors}
            />
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <InputField
              name="swift"
              label={i18n.t('modals.modalCreateNewLegalEntity.fields.swift.title')}
              required={true}
              value={stepFields.swift}
              setValue={(value) => {
                setFields({ ...stepFields, swift: value });
              }}
              getFieldErrors={getFieldErrors}
            />
          </Col>
            <Col lg={8} md={8} sm={24} xs={24}>
            <InputField
              name="bankAddress"
              label={i18n.t('modals.modalCreateNewLegalEntity.fields.bankAddress.title')}
              title={i18n.t('modals.modalCreateNewLegalEntity.fields.bankAddress.title')}
              required={true}
              value={stepFields.bankAddress}
              setValue={(value) => {
                setFields({ ...stepFields, bankAddress: value });
              }}
              getFieldErrors={getFieldErrors}
            />
          </Col>
        </Row>

        <span className="divider-label">{i18n.t('modals.modalCreateNewLegalEntity.divider.correspondentBank')}</span>
        <DividerBlock style={dividerStyle} />

        <Row gutter={[{ xs: 0, sm: 0, md: 16}, 24]}>
            <Col lg={8} md={8} sm={24} xs={24}>
                <InputField
                    name="correspondentBankName"
                    title={i18n.t('modals.modalCreateNewLegalEntity.fields.correspondentBankName.title')}
                    label={i18n.t('modals.modalCreateNewLegalEntity.fields.correspondentBankName.title')}
                    required={true}
                    value={stepFields.correspondentBankName}
                    setValue={(value) => {
                        setFields({ ...stepFields, correspondentBankName: value });
                    }}
                    getFieldErrors={getFieldErrors}
                />
            </Col>
            <Col lg={8} md={8} sm={24} xs={24}>
                <InputField
                    name="correspondentBankInn"
                    title={i18n.t('modals.modalCreateNewLegalEntity.fields.correspondentBankInn.title')}
                    label={i18n.t('modals.modalCreateNewLegalEntity.fields.correspondentBankInn.title')}
                    required={true}
                    value={stepFields.correspondentBankInn}
                    setValue={(value) => {
                        setFields({ ...stepFields, correspondentBankInn: value });
                    }}
                    getFieldErrors={getFieldErrors}
                />
            </Col>
            <Col lg={8} md={8} sm={24} xs={24}>
                <InputField
                    name="correspondentBankBic"
                    label={i18n.t('modals.modalCreateNewLegalEntity.fields.correspondentBankBic.title')}
                    title={i18n.t('modals.modalCreateNewLegalEntity.fields.correspondentBankBic.title')}
                    required={true}
                    value={stepFields.correspondentBankBic}
                    setValue={(value) => {
                        setFields({ ...stepFields, correspondentBankBic: value });
                    }}
                    getFieldErrors={getFieldErrors}
                />
            </Col>
            <Col lg={8} md={8} sm={24} xs={24}>
                <InputField
                    name="correspondentBankAccount"
                    label={i18n.t('modals.modalCreateNewLegalEntity.fields.correspondentBankAccount.title')}
                    title={i18n.t('modals.modalCreateNewLegalEntity.fields.correspondentBankAccount.title')}
                    required={true}
                    value={stepFields.correspondentBankAccount}
                    setValue={(value) => {
                        setFields({ ...stepFields, correspondentBankAccount: value });
                    }}
                    getFieldErrors={getFieldErrors}
                />
            </Col>
            <Col lg={8} md={8} sm={24} xs={24}>
                <InputField
                    name="correspondentBankCheckingAccount"
                    label={i18n.t('modals.modalCreateNewLegalEntity.fields.correspondentBankCheckingAccount.title')}
                    title={i18n.t('modals.modalCreateNewLegalEntity.fields.correspondentBankCheckingAccount.title')}
                    required={true}
                    value={stepFields.correspondentBankCheckingAccount}
                    setValue={(value) => {
                        setFields({ ...stepFields, correspondentBankCheckingAccount: value });
                    }}
                    getFieldErrors={getFieldErrors}
                />
            </Col>
            <Col lg={24} md={24} sm={24} xs={24}>
                <InputField
                    name="correspondentBankLegalAddress"
                    label={i18n.t('modals.modalCreateNewLegalEntity.fields.correspondentBankLegalAddress.title')}
                    title={i18n.t('modals.modalCreateNewLegalEntity.fields.correspondentBankLegalAddress.title')}
                    required={true}
                    value={stepFields.correspondentBankLegalAddress}
                    setValue={(value) => {
                        setFields({ ...stepFields, correspondentBankLegalAddress: value });
                    }}
                    getFieldErrors={getFieldErrors}
                />
            </Col>
        </Row>

        <span className="divider-label">{i18n.t('modals.modalCreateNewLegalEntity.divider.info')}</span>
        <DividerBlock style={dividerStyle} />

        <Row gutter={[16, 24]}></Row>
        <Row gutter={[16, 24]}>
          <Col lg={8} md={8} sm={24} xs={24}>
            <InputField
              name="phone"
              title={i18n.t('modals.modalCreateNewLegalEntity.fields.phoneMobile.title')}
              label={i18n.t('modals.modalCreateNewLegalEntity.fields.phoneMobile.title')}
              required={true}
              value={stepFields.phone}
              setValue={(value) => {
                setFields({ ...stepFields, phone: value });
              }}
              getFieldErrors={getFieldErrors}
            />
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <InputField
              name="email"
              label={i18n.t('modals.modalCreateNewLegalEntity.fields.email.title')}
              required={true}
              value={stepFields.email}
              setValue={(value) => {
                setFields({ ...stepFields, email: value });
              }}
              getFieldErrors={getFieldErrors}
            />
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <InputField
              name="atiCode"
              label={i18n.t('modals.modalCreateNewLegalEntity.fields.atiCode.title')}
              isDisabled={notRegisteredATI}
              required={true}
              value={stepFields.atiCode}
              setValue={(value) => {
                setFields({ ...stepFields, atiCode: value });
              }}
              getFieldErrors={getFieldErrors}
            />
            <Checkbox
              name="notRegisteredATI"
              checked={notRegisteredATI}
              onChange={(e) => {
                setFields({
                  ...stepFields,
                  atiCode: e.target.checked ? i18n.t('modals.modalCreateNewLegalEntity.fields.noAtiCode.title') : "",
                });
                setNotRegisteredATI(e.target.checked);
              }}
              style={{ fontSize: "10pt", paddingTop: "15px" }}
            >
              {i18n.t('modals.modalCreateNewLegalEntity.fields.notRegisteredATI.title')}
            </Checkbox>
          </Col>
        </Row>
      </>
    );
}
